export default __webpack_public_path__ + "static/winter20-c9711315a8d3146653cdddff5824751e.webp";